import { FormlyFieldConfig } from '@ngx-formly/core';
import { DetailsFormOptions } from './details-form-options.interface';

/**
 * SECTION 2.4: CLIENT BANKING QUESTIONS
 */
export function getClientBankingFields(options: DetailsFormOptions): FormlyFieldConfig[] {
	return [
		// Banking Information
		{
			fieldGroupClassName: 'row',
			fieldGroup: [
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Financial_Institution_Name',
					type: 'input',
					props: {
						label: 'Financial Institution Name',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Financial_Institution_Number',
					type: 'input',
					props: {
						label: 'Financial Institution Number',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Bank_Account_Number',
					type: 'input',
					props: {
						label: 'Bank Account Number',
					},
				},
				{
					className: 'col-sm-6 col-lg-4',
					key: 'Bank_Transit_No',
					type: 'input',
					props: {
						label: 'Bank Transit Number',
					},
				},
				{
					className: 'col-sm-8',
					key: 'Branch_Address',
					type: 'input',
					props: {
						label: 'Branch Address',
					},
				},
			],
		},
	];
}